module.exports = __webpack_public_path__ + "img/hbykdxdyyy.ffeca385.png";